import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

export default function FormHeaderComponent(props) {
  return (
    <Box
      sx={{
        paddingBottom: "2rem",
      }}
    >
      <Typography variant="h5" component="h2" gutterBottom>
        {props.title}
      </Typography>
      {props.description && (
        <Typography
          variant="p"
          component="div"
          gutterBottom
          sx={{
            paddingBottom: "1rem",
          }}
        >
          {props.description}
        </Typography>
      )}
      <Divider />
      {props.children}
    </Box>
  );
}
